// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__WmKvz","insightsList":"newBusinessInsightsMenu_insightsList__2rAst","active":"newBusinessInsightsMenu_active__3s1d8"};